import styled from 'styled-components';

export const CustomSelect = styled.div`
  padding: 0 6px;
  div.item-heading {
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 6px;
    color: #12344d;
  }
  div.item-desc {
    font-weight: normal;
    font-size: 11px;
    line-height: 20px;
    color: #12344d;
  }
`;

export const ToggleWrapper = styled.div`
  &.flex {
    display: flex;
    align-items: center;
    & > :not(:last-child) {
      margin-right: 12px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    & > :not(:last-child) {
      margin-right: 12px;
    }
  }
  .toggle-label {
    font-size: 12px;
    font-weight: 400;
  }
`;
